/* tslint:disable */
/* eslint-disable */
/**
 * Farseer API
 * Farseer API
 *
 * The version of the OpenAPI document: 3
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export function ExportModelTableRequestFromJSON(json) {
    return ExportModelTableRequestFromJSONTyped(json, false);
}
export function ExportModelTableRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        path: json['path'],
        expandedOnly: json['expandedOnly'],
        filterDimensionIds: json['filterDimensionIds'],
    };
}
export function ExportModelTableRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        path: value.path,
        expandedOnly: value.expandedOnly,
        filterDimensionIds: value.filterDimensionIds,
    };
}
